import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faCirclePlay,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import ProgressBar from "../athlete-progress-bar";
import { useActVideo } from "../../../hooks/useActVideo";
import { TooltipStart } from "../tooltip-start";
import { useSelector } from "react-redux";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { getExerciseHistoryService } from "../../../services/AthleteService";
import { useAxiosInstance } from "../../../services/Interceptor";
import GraphModal from "../graphModal";
import { InchesToFeetAndInches } from "../../../utils/functions";
import ReactPlayer from "react-player";
import { isFortyYardDash, isFortyYardSplit } from "./combine-metrics";

const PositionScoreTemplate = ({ result, athleteId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [video, setVideo] = useState();
  const [titleName, setTitleName] = useState();
  const actVideo = useActVideo(result);
  const r_athlete = useSelector((state) => state.athletes);
  const authUser = useAuthUser();

  const [isGraphOpen, setIsGraphOpen] = useState(false);
  const [exerciseData, setExerciseData] = useState([]);
  const [exerciseName, setExerciseName] = useState("");
  const [stage, setStage] = useState("");
  const apiInstance = useAxiosInstance();
  const [isDownloading, setIsDownloading] = useState(false);

  const fetchExerciseData = async () => {
    if (!athleteId) return;

    try {
      const data = await getExerciseHistoryService(
        apiInstance,
        athleteId,
        result.physicalTestName,
        result.stage,
      );
      setExerciseData(Array.isArray(data) ? data : [data]);
      setExerciseName(result.physicalTestName);
      setStage(result.stage);
    } catch (error) {
      console.error("Error al obtener datos:", error);
    }
  };

  const openGraphModal = async () => {
    await fetchExerciseData();
    setIsGraphOpen(true);
  };

  const openModalFN = (video, physicalTestName) => {
    setVideo(video);
    setIsOpen(true);
    setTitleName(physicalTestName);
  };

  const closeModalFN = () => {
    setVideo("");
    setIsOpen(false);
  };

  if (
    result.fieldId === 17 &&
    (!result.stageValue ||
      result.stageValue === "0.000" ||
      result.stageValue === "" ||
      result.stageValue == null ||
      result.stageValue === 0)
  ) {
    return null;
  }

  if (
    result.fieldId === 18 &&
    (!result.stageValue ||
      result.stageValue === "0.000" ||
      result.stageValue === "" ||
      result.stageValue == null ||
      result.stageValue === 0)
  ) {
    return null;
  }

  const isFortyYardDashEvent = isFortyYardDash(result.physicalTestName);
  const shouldShowTopMph =
    isFortyYardDashEvent && isFortyYardSplit(result.stage);
  const topMph = shouldShowTopMph
    ? result.auxiliaryValue1 !== 0.0
      ? result.auxiliaryValue1
      : null
    : null;

  const handleDownload = async () => {
    if (!video) return;
    setIsDownloading(true);
    try {
      const blob = await (await fetch(video)).blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "video.mp4";
      a.click();

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error("Download error:", err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-1 xl:gap-5 sm:flex-row sm:items-center bg-white shadow rounded-lg border border-gray-200 py-2 px-3 w-full mb-2">
        <div className="flex items-center justify-between w-full sm:w-3/4 space-x-8">
          <div className="flex flex-col w-full">
            <div className={`flex`}>
              {isFortyYardDashEvent ? (
                <div className="font-normal text-gray-600">
                  {result.stage === "40" ? (
                    result.physicalTestName
                  ) : (
                    <div>
                      {result.physicalTestName}
                      <span className="text-gray-400"> → </span> {result.stage}{" "}
                      Yard Split
                    </div>
                  )}
                </div>
              ) : (
                <div className="font-normal text-gray-600">
                  {result.physicalTestName}:{" "}
                </div>
              )}
              <div className="flex justify-between">
                {result.physicalTestName === "Vertical jump" && (
                  <>
                    {result.value}
                    <div className="text-sm pt-1 pl-2">
                      Standing Reach: {result.auxiliaryValue1} &nbsp;&nbsp;
                      Maximum Jump: {result.auxiliaryValue2}
                    </div>
                  </>
                )}
              </div>
              {result.physicalTestName === "Bench press" ? (
                <div className="font-normal text-gray-900">
                  <span className="pl-4 font-medium text-gray-900">
                    {" "}
                    {result.stageValue}
                  </span>
                </div>
              ) : (
                <div className="font-normal text-gray-600"></div>
              )}
              {result.physicalTestName === "Bench press" && (
                <div className="font-normal text-gray-900">
                  <span className="pl-4 font-medium text-gray-900">
                    {" "}
                    {result.reps}{" "}
                  </span>
                </div>
              )}

              {result.physicalTestName === "Med Ball" && (
                <div className="font-normal text-gray-600">
                  <span className="pl-4 font-medium text-gray-900">
                    {" "}
                    {InchesToFeetAndInches(result.stageValue)}{" "}
                  </span>
                </div>
              )}
              {result.physicalTestName !== "Bench press" &&
                result.physicalTestName !== "Med Ball" && (
                  <div className="font-normal text-gray-600">
                    <span className="pl-4 font-medium text-gray-900">
                      {" "}
                      {result.stageValue}
                    </span>
                  </div>
                )}
              {topMph !== null && (
                <div className="pl-4 text-sm text-gray-600 flex items-center">
                  (<span className=" text-gray-600"> Top MPH:</span>{" "}
                  <span className="text-gray-800 font-medium pl-1">
                    {" "}
                    {topMph}
                  </span>
                  )
                </div>
              )}
            </div>
            {!(
              authUser?.user?.role === "athlete" &&
              !r_athlete?.profile?.hasCurrentSubscription
            ) && (
              <div className="w-full ProgressBar-size">
                <ProgressBar
                  score={
                    result.positionAthleticScore
                      ? Number.parseInt(result.positionAthleticScore)
                      : 0
                  }
                />
              </div>
            )}

            <GraphModal
              isOpen={isGraphOpen}
              closeModal={() => setIsGraphOpen(false)}
              exerciseData={exerciseData}
              exerciseName={exerciseName}
              stage={stage}
            />
          </div>
        </div>

        <div className="flex items-center justify-start lg:justify-end xl:justify-end sm:w-1/4 space-x-4 sm:mt-0 ">
          <div className={`${actVideo ? "grid items-center" : "hidden"}`}>
            <FontAwesomeIcon
              icon={faCirclePlay}
              className={`h-5 ml-2 ${result.videoUrl === "" ? "cursor-auto text-gray-400 opacity-50" : "cursor-pointer text-black"} ${actVideo ? "block" : "hidden"}`}
              onClick={() =>
                result.videoUrl === ""
                  ? ""
                  : openModalFN(result.videoUrl, result.physicalTestName)
              }
            />
            <span className="text-[12px] text-gray-600 font-normal">Video</span>
          </div>

          <div className="relative group">
            <img
              src="/chart (1).svg"
              alt="graph"
              className="cursor-pointer hover:opacity-80 h-5 pl-2 mt-1"
              onClick={openGraphModal}
            />
            <span className="text-[12px] text-gray-600 font-normal">
              {" "}
              Trends
            </span>
          </div>

          <div className="relative group grid">
            <FontAwesomeIcon
              icon={faCircleInfo}
              className="h-5 cursor-pointer text-gray-800"
            />
            <span className="text-[12px] text-gray-600 font-normal"> Info</span>

            <TooltipStart result={result} />
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-gray-900 opacity-50"></div>

          <div className="bg-white rounded-lg shadow-lg z-50 max-w-screen-lg w-full p-4">
            <div className="flex justify-between items-center mb-4">
              <div className="text-xl font-bold flex">
                {titleName}
                <div className="flex items-center pl-16 font-normal">
                  {video && (
                    <button
                      onClick={handleDownload}
                      disabled={isDownloading}
                      className={`ml-2 px-3 py-1 rounded text-sm flex items-center gap-2 ${
                        isDownloading
                          ? "text-gray-400 cursor-not-allowed"
                          : "text-gray-600 hover:text-black"
                      } bg-transparent`}
                    >
                      {isDownloading ? "Downloading..." : "Download"}
                      <FontAwesomeIcon
                        icon={faDownload}
                        className="text-gray-500"
                      />
                    </button>
                  )}
                </div>
              </div>
              <button
                className="text-gray-600 hover:text-black text-xl font-bold safari-text"
                onClick={closeModalFN}
              >
                ✕
              </button>
            </div>

            <div className="relative p-0 w-full">
              <div className=" h-[480px] bg-black">
                <ReactPlayer
                  controls
                  light={true}
                  src={video}
                  playsInline={true}
                  width="100%"
                  height="480px"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PositionScoreTemplate;
